import { useState } from 'react';

import type { useSectionBrowserParams } from '../../../../components/DealerPage/components/SectionBrowser/SectionBrowser.typed';

function useSectionBrower(params: useSectionBrowserParams) {
  const {
    sections,
    onSelectBack,
    onSelectSection,
    collapsible,
    parentSection,
    baseUrl,
  } = params;
  const [collapsed, setCollapsed] = useState(true);
  const filteredSubsections = sections.filter(
    (section) => section.searchMatches && section.searchMatches > 0,
  );
  const showSubsections = filteredSubsections.length > 0;
  const SECTION_DISPLAY_LIMIT = 10;
  const shouldCollapse =
    collapsible && filteredSubsections.length > SECTION_DISPLAY_LIMIT;

  const handleSelectBack = () => {
    parentSection && onSelectBack(parentSection.name);
  };

  const handleSelectSection = (section: string) => {
    onSelectSection(section);
  };

  function getLink(name: string) {
    return baseUrl ? `${baseUrl}/${name}` : `/${name}`;
  }

  return {
    collapsed,
    setCollapsed,
    handleSelectBack,
    shouldCollapse,
    handleSelectSection,
    getLink,
    showSubsections,
    filteredSubsections,
  };
}

export { useSectionBrower };
